var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Text } from 'shared/components/ui';
import { UsersSearchBox } from 'src/pages/Settings/Users/components/usersSearchBox';
import { useCallback } from 'react';
import { useFlagEnabled } from 'src/flagging/hooks';
export var ViewAsInputBox = function (props) {
    var setViewAsUser = props.setViewAsUser, boxProps = __rest(props, ["setViewAsUser"]);
    var userFilter = useCallback(function (user) { return Boolean(user.care_provider); }, []);
    var inHouseFilter = useFlagEnabled('VIEW_AS_IN_HOUSE_AVAILABILITY_FILTER');
    return (_jsxs(Box, __assign({ backgroundColor: "white", position: "fixed", p: "24px", w: "512px", h: "400px", bottom: "0px", left: "75px", borderWidth: "1px", borderColor: "gray.350", borderRadius: "4px", m: 0, zIndex: "overlay" }, boxProps, { children: [_jsx(Text, __assign({ fontSize: "21px", lineHeight: "27px", fontWeight: 600, fontFamily: "body" }, { children: "View as another caregiver" })), _jsx(UsersSearchBox, { onUserSelect: setViewAsUser, placeholder: "Search by name or email", userFilter: userFilter, inHouseFilter: inHouseFilter }), _jsx(Box, __assign({ ml: "16" }, { children: _jsx(Text, __assign({ textColor: "gray.500", fontSize: "16px", lineHeight: "24px", fontWeight: 400, fontFamily: "body" }, { children: "Begin typing to search for a caregiver." })) }))] })));
};
